enum ELanguageIds {
  Armenian = 1,
  English,
  Russian,
}

enum ETranslationModules {
  Dashboard = 1,
  Feedback,
  Campaigns,
  Customers,
  Roles,
  Users,
  Translation,
}

export { ELanguageIds, ETranslationModules };
